import { Receipt } from './../../models/receipt';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PaymentService } from 'src/app/services/payment.service';
import { Router, ActivatedRoute } from '@angular/router';
import { faPrint, IconDefinition, faArrowLeft, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Location } from '@angular/common';
import { downloadPdf } from 'src/app/util/tools';
import { FormGroup, FormControl } from '@angular/forms';
import { checkFormat } from "../../util/tools"
import { EMAIL_REGEXP } from 'src/app/util/constants';


@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReceiptComponent implements OnInit {

  public receipt: Receipt;
  public printIcon: IconDefinition = faPrint;
  public backIcon: IconDefinition = faArrowLeft;
  public sendMailIcon: IconDefinition = faEnvelope;
  public form: FormGroup;
  public emailWrongFormat: boolean;
  public userEmail: string;
  public emailSuccess: boolean;
  public guid: string;

  constructor(public paymentService: PaymentService, private router: Router, private activatedRoute: ActivatedRoute, public location: Location) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      const { id } = params;
      this.guid = id;
      this.getItemReceipt(id);
    });
    this.createEmailForm();
  }

  public createEmailForm(): void {
    this.form = new FormGroup({
      email: new FormControl()
    });
  }

  public validateEmail(value: string): void {
    const emailRegex = EMAIL_REGEXP;
    this.emailWrongFormat = checkFormat(value, emailRegex);
  }

  onKeyUp(event) {
    const { value } = event.target;
    this.validateEmail(value);
  }

  public onSubmit() {
    const { email } = this.form.getRawValue();
    this.validateEmail(email);
    if (!this.emailWrongFormat) {
      this.paymentService.sendReceiptToEmail(this.guid, email).subscribe(response => {
        const { IsSuccess } = response[0];
        this.emailSuccess = !(response instanceof HttpErrorResponse || !IsSuccess);
        this.userEmail = email;
      });
    }
  }

  public print(): void {
    const { PDF } = this.receipt;
    downloadPdf(PDF, 'Receipt');
  }

  public back(): void {
    this.location.back();
  }

  public getItemReceipt(id: string): void {
    this.paymentService.getItemReceipt(id).subscribe(response => {
      if (response instanceof HttpErrorResponse) {
        this.router.navigate(['notfound']);
      } else {
        this.receipt = response[0];
      }
    })
  }

}
